/* eslint-disable react/jsx-props-no-spreading */
import { type SVGProps } from 'react';

const MoveOptionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={30}
    height={30}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="MoveOptionIcon">
    <path
      d="M17.5 2.5a10 10 0 0 1 4.115 19.116A10 10 0 1 1 8.382 8.384 10.004 10.004 0 0 1 17.5 2.5Zm-5 7.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Zm5-5a7.48 7.48 0 0 0-5.605 2.516 10 10 0 0 1 10.588 10.589A7.5 7.5 0 0 0 17.5 5Z"
      fill="var(--moreMenuIconFill)"
      stroke="var(--moreMenuIconStroke)"
      strokeWidth={0.8}
    />
    <path
      d="M11.647 20.823H9v-7.058h2.647V12h1.765v1.765h.882a2.206 2.206 0 0 1 1.765 3.53 2.206 2.206 0 0 1-1.765 3.528h-.882v1.765h-1.765v-1.765Zm-.882-2.646v.882h3.53a.442.442 0 0 0 0-.883h-3.53Zm0-2.648v.883h3.53a.441.441 0 0 0 0-.883h-3.53Z"
      fill="var(--primaryTheme)"
      stroke="var(--moreMenuIconStroke)"
      strokeWidth={0.4}
    />
  </svg>
);

export default MoveOptionIcon;
